import React, { useEffect, useState } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import { CheckCircleOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Spin, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import ComplianceModal from './ComplianceModal';
import ZenModal from '../../components/ZenModal';
import { useSelector } from 'react-redux';
import { createRoute } from '../../utils/CustomFunc';

const MessageBox = (props) => {
    const [messagesData, setMessageData] = useState();
    const urlCode = useSelector(state => state.urlCode);
    const [messagesLoading, setMessagesLoading] = useState(false);
    const [currentMessage, setCurrentMessage] = useState();
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [img, setImg] = useState();
    const [DataModal, setDataModal] = useState({ visible: false, data: null });
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });
    const [zenModal, setZenModal] = useState();


    const toggleModal = ({ show = false, data = undefined, type = 'kanban', loading = false }) => {
        setModal({ show, data, type, loading });
    }

    const zenPopupAction = (zenPopup, value) => {
        let urlData = { ...zenPopup.params };
        urlData.lid = props.selectedLid;
        if(zenPopup?.props){
            urlData[zenPopup?.props] = value;
        }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
    }

    const onColumnClick = () => {
        let currentMessageId = currentMessage?.config?._id;
        let zenPopDataIndex = messagesData?.config?.zenPop[currentMessageId];
        console.log(zenPopDataIndex)
        if (!zenPopDataIndex) return;
        setZenModal(zenPopDataIndex);
        if (zenPopDataIndex?.typ === 'newTab') {
            let zenParams = { ...zenPopDataIndex.params };
            zenParams.lid = props.selectedLid;
            if (zenPopDataIndex?.api) {
                zenParams.api = zenPopDataIndex?.api;
            }
            let route = createRoute({
                props: zenPopDataIndex?.props,
                record: currentMessage?.config,
                multiProps: zenPopDataIndex?.multiProps,
                params: { ...zenParams },
                urlCode,
                route: zenPopDataIndex?.urlType === 'dynamic' ? currentMessage?.config[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
            });
            window.open(route, '_blank')
            return;
        };
        zenPopupAction(zenPopDataIndex, currentMessageId)
    }

    const [ref, setRef] = useState(true);

    const modalHandler = () => {
        setDataModal({ visible: false, data: null });
    };

    useEffect(() => {
        let timer;
        if (currentMessage) {
            timer = setTimeout(() => {
                let newIndex = currentMessageIndex + 1;
                if (newIndex === messagesData?.data?.length) {
                    newIndex = 0;
                }
                setCurrentMessageIndex(newIndex);
                setCurrentMessage(messagesData?.data[newIndex]);
            }, (currentMessage?.config?.interval * 1000));
        }
        return (() => clearTimeout(timer))
    }, [currentMessage]);

    const changeCurrentMessage = (index) => {
        setCurrentMessageIndex(index);
        setCurrentMessage(messagesData?.data[index]);
    };

    const onClickHandler = () => {
        setDataModal({ visible: true, data: currentMessage?.action });
    };


    const getData = () => {
        liracrypt.get('/linedash/basemsg', { lid: props?.selectedLid })
            .then(res => {
                if (!res.data) return;
                if (res.data.data.length === 0) return;
                setMessageData(res.data);
                if (!currentMessage) {
                    setCurrentMessage(res.data.data[0]);
                    setCurrentMessageIndex(0);
                }
                setMessagesLoading(false);
            }).catch(err => {
                console.log(err);
            })
    }

    useEffect(() => {
        setMessagesLoading(true);

        getData();
        let interval = setInterval(() => {
            getData();
        }, 60000);
        return (() => clearInterval(interval))
    }, []);

    useEffect(() => {
        if (currentMessage) {
            let cacheImg = localStorage.getItem(`cache_img_${currentMessage?.image?.src}`);
            if (cacheImg) {
                setImg(cacheImg);
                return;
            }
            liracrypt.get('/imagecontrol', { _id: currentMessage?.image?.src })
                .then(res => {
                    if (res.status === 200) {
                        setImg(res.data.data);
                        localStorage.setItem(`cache_img_${currentMessage?.image?.src}`, res.data.data);
                    } else {
                        let noImg = require(`../../assets/static/noImg.jpeg`);
                        setImg(noImg);
                        localStorage.setItem(`cache_img_${currentMessage?.image?.src}`, noImg);
                    }
                }).catch(err => {
                    console.log(err);
                    let noImg = require(`../../assets/static/noImg.jpeg`);
                    setImg(noImg);
                })
        }
    }, [currentMessage]);

    return (
        messagesLoading ? <p>...</p> :
            <div className='message-box' style={{ backgroundColor: currentMessage?.config?.backgroundColor }}>
                <div className="message-header" style={{ backgroundColor: '#525252' }}>
                    <div>
                        <p className='message-time' style={{ color: '#ffffff' }}>{currentMessage?.config?.time}</p>
                        <p className='message-sender' style={{ color: '#ffffff' }}>{currentMessage?.config?.sender}</p>
                    </div>
                    <div className='message-action'>
                        <Button disabled={currentMessageIndex === 0} onClick={() => changeCurrentMessage(currentMessageIndex - 1)} type='ghost'>
                            <LeftOutlined style={{ color: '#ffffff', fontSize: 20 }} />
                        </Button>
                        <Button disabled={(currentMessageIndex + 1) === messagesData?.data?.length} onClick={() => changeCurrentMessage(currentMessageIndex + 1)} type='ghost'>
                            <RightOutlined style={{ color: '#ffffff', fontSize: 20 }} />
                        </Button>
                        <a className="ant-btn css-dev-only-do-not-override-1e3x2xa ant-btn-ghost" target="_blank" href={`/v02/${urlCode}/lineperformance?lid=${props.selectedLid}`}>
                            <i style={{ fontSize: 20 }} className={`fa fa-newspaper-o`}></i>
                        </a>
                    </div>
                </div>
                <div className='message-body'>
                    <img style={{ height: 100, width: 'auto', ...currentMessage?.image?.style }} src={img} alt="message-img" />
                    <div className="message-list">
                        {
                            currentMessage?.msg.map((x, i) => (
                                <p key={i} style={x.style}>{x.text}</p>
                            ))
                        }
                    </div>
                    <Tooltip title={currentMessage?.action?.toolTip}>
                        <Button type="ghost" onClick={onColumnClick}>
                            <i style={currentMessage?.action?.icon?.style} className={`fa ${currentMessage?.action?.icon?.src}`}></i>
                        </Button>
                    </Tooltip>
                </div>

                <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} />


                <ComplianceModal
                    data={DataModal}
                    modalHandler={modalHandler}
                    extraData={{ dictName: "Format_Smodal", messageId: currentMessage?.config?._id }}
                    selectedLid={props.selectedLid}
                    refreshLineDashboard={props.refreshLineDashboard}
                />
            </div>
    )
};

export default MessageBox;